import { render, staticRenderFns } from "./CreateLoyaltyScheme.vue?vue&type=template&id=68d5b4d0&scoped=true"
import script from "./CreateLoyaltyScheme.vue?vue&type=script&lang=js"
export * from "./CreateLoyaltyScheme.vue?vue&type=script&lang=js"
import style0 from "./CreateLoyaltyScheme.vue?vue&type=style&index=0&id=68d5b4d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d5b4d0",
  null
  
)

export default component.exports